import { ApiTeam, ApiBQResponse, ApiVizPageCreateRequest, ApiPage, ApiBQQuery, ApiUser } from "./api_data";
import { Teams } from "./teams";
import { div, span, anchor, textnode } from "../../shared/dom";
import { App } from "./app";
import { Overlay, OverlayStyle } from "../../shared/overlay";
import { Ajax } from "../../shared/ajax";
import { Loading } from "../../shared/loading";
import { DropdownState } from "../../shared/dropdown";
import { Upload } from "./upload";
import uuid = require("uuid");
import { timeAgoDateFormat } from "../../shared/date_format";
import { Menu } from "../../shared/menu";
import { VizSVG } from "./viz_svg";
import { SVG } from "../../shared/svg";
import { Settings } from "./settings";
import { Graph } from "../../shared/graph";

export interface SectionHeader {
  button: HTMLElement;
  container: HTMLElement;
}

export interface VizListOpts {
  show_menu: boolean;
  columns: number;
}

export class FilesPage {

  static render_data_links(container: HTMLElement) {

    let empty = true;
    if (App.table_sets[App.selected_owner_id] !== undefined) {
      for (const table of App.table_sets[App.selected_owner_id]) {
        const is_upload = table.project_id === "daytum-viz";
        empty = false;
        const t = div("data-link");
        t.innerText = table.id;
        t.appendChild(VizSVG.large_table_icon());
        const count = div("count");
        count.innerText = Graph.compact_number(table.row_count);
        t.appendChild(count);
        const label = div("meta");
        const date = new Date(table.creation_time);
        const updated = timeAgoDateFormat(date);
        const dataset = is_upload ? "Import" : table.dataset_id;
        const dot = span("dot");
        dot.innerText = " • ";
        label.innerText = dataset;
        label.appendChild(dot);
        label.appendChild(textnode(updated));
        t.appendChild(label);
        container.appendChild(t);

        if (is_upload) {
          const menu = Menu.menu();
          t.appendChild(menu.container);
          Menu.add_menu_item(menu, "Delete", function () {
            const message = "This will permanently delete the table <b>" + table.id + "</b>.";
            const confirm = "To confirm type the name of the table below";
            Overlay.deleteConfirmByTypingOverlay("Delete Table", message, confirm, table.id, function () {
              Overlay.disableDismissal();
              const path = "/api/v1/bq_tables/" + table.project_id + "/" + table.dataset_id + "/" + table.id;
              Ajax.delete(path, function () {
                if (App.table_sets[table.owner_id] !== undefined) {
                  const filtered = [];
                  for (const t of App.table_sets[table.owner_id]) {
                    if (t.dataset_id === table.dataset_id && t.id === table.id) {
                      continue;
                    }
                    filtered.push(t);
                  }
                  App.table_sets[table.owner_id] = filtered;
                }
                App.render();
                Overlay.enableDismissal();
                Overlay.close();
              }, function () {
                const button = document.querySelector("div.overlay-panel-footer a.button");
                if (button) {
                  button.classList.remove("working");
                }
                Overlay.enableDismissal();
              })
            });
          });
        }

        t.onclick = function () {
          const d = div("data-preview", "loading");
          const loading = Loading.overlay();
          d.appendChild(loading);
          const table_path = table.dataset_id + "." + table.id;
          let q_str = "SELECT * FROM " + table_path;
          if (table.columns && table.columns.length > 0) {
            q_str += " ORDER BY " + table.columns[0].name + " ASC";
          }
          q_str += " LIMIT 100;"
          const q: ApiBQQuery = {
            project_id: table.project_id,
            dataset_id: table.dataset_id,
            table_id: table.id,
            query: q_str
          }
          Ajax.post("/api/v1/bq_query", function (data: ApiBQResponse) {
            const table = document.createElement("table");
            const t_head = document.createElement("thead");
            const t_head_row = document.createElement("tr");
            t_head.appendChild(t_head_row);
            table.appendChild(t_head);

            const idx_th = document.createElement("th");
            idx_th.classList.add("idx");
            t_head_row.appendChild(idx_th);
            for (const s of data.schema) {
              const th = document.createElement("th");
              th.innerText = s.name;
              t_head_row.appendChild(th);
            }
            let idx = 0;
            for (const row of data.rows) {
              const tr = document.createElement("tr");
              const index_td = document.createElement("td");
              index_td.classList.add("idx");
              index_td.innerText = (idx + 1).toString();
              tr.appendChild(index_td);
              for (const col of row) {
                const td = document.createElement("td");
                td.innerText = col;
                tr.appendChild(td);
              }
              table.appendChild(tr);
              idx++;
            }
            d.insertBefore(table, d.firstChild);
            d.classList.remove("loading");
          }, q);

          const overlay = new Overlay(OverlayStyle.Viz, table.id, [d], "", function () {
            //
          });
          overlay.panel.classList.add("large");
        }
      }
    }

    if (empty) {
      const empty = div("empty-list");
      empty.innerHTML = "No data";
      container.appendChild(empty);
    }
  }

  static render_page_links(pages: ApiPage[], container: HTMLElement, click_cb: Function) {
    const cols_container = div("viz-link-columns");
    container.appendChild(cols_container);
    const cols = [];
    const heights: number[] = [];

    const width = container.getBoundingClientRect().width;
    const size = 240;
    const padding = 30;
    const link_height = 170;

    let col_count = Math.floor((width + padding) / (size + padding));
    if (col_count <= 0) {
      col_count = 1;
    }

    for (let i = 0; i < col_count; i++) {
      const col = div("viz-link-col");
      cols_container.appendChild(col);
      cols.push(col);
      heights.push(0);
    }

    function min_col_idx() {
      if (heights.length === 0) {
        return 0;
      }
      const min = heights.reduce(function (a, b) {
        return Math.min(a, b);
      });
      for (let i = 0; i < heights.length; i++) {
        if (heights[i] === min) {
          return i;
        }
      }
      return 0;
    }

    let empty = true;
    for (const page of pages) {
      empty = false;
      const viz_el = div("viz-link");
      const img = div("viz-link-img");
      img.style.backgroundImage = "url(https://storage.googleapis.com/daytum-viz-thumbnails/" + page.id + ".png?" + page.version + ")";
      const w = 240;
      const h = 190;
      img.style.width = w + "px";
      img.style.height = h + "px";
      img.onclick = function () {
        click_cb(page);
      }
      const title = div("viz-link-title");
      title.innerText = page.title;
      const meta = div("meta");
      const date = new Date(page.created_at);
      meta.innerText = timeAgoDateFormat(date);
      viz_el.appendChild(img);
      viz_el.appendChild(title);
      viz_el.appendChild(meta);

      const view = anchor("view-icon");
      view.appendChild(VizSVG.open_icon());
      title.appendChild(view);

      view.href = "/page/" + page.id;
      view.onclick = function (e) {
        if (e.button === 0 && !e.ctrlKey && !e.metaKey) {
          e.preventDefault();
          window.open(view.href, "_blank");
        }
      }

      const menu = Menu.menu();
      title.appendChild(menu.container);
      Menu.add_menu_item(menu, "Delete", function () {
        const message = "Are you sure you want to delete <b>" + page.title + "</b>?";
        Overlay.deleteConfirmOverlay("Delete Page", message, function () {
          Overlay.disableDismissal();
          const path = "/api/v1/pages/" + page.id;
          Ajax.delete(path, function () {
            if (App.page_sets[page.owner_id] !== undefined) {
              const filtered = [];
              for (const p of App.page_sets[page.owner_id]) {
                if (p.id === page.id) {
                  continue;
                }
                filtered.push(p);
              }
              App.page_sets[page.owner_id] = filtered;
            }
            App.render();
            Overlay.enableDismissal();
            Overlay.close();
          }, function () {
            const button = document.querySelector("div.overlay-panel-footer a.button");
            if (button) {
              button.classList.remove("working");
            }
            Overlay.enableDismissal();
          });
        });
      });

      const min_idx = min_col_idx();
      heights[min_idx] += link_height;
      cols[min_idx].appendChild(viz_el);
    }
    if (empty) {
      const empty = div("empty-list");
      empty.innerHTML = "No pages";
      container.appendChild(empty);
    }
  }

  static render_left_rail(container: HTMLElement) {
    container.innerHTML = "";

    const rename_team = function (team: ApiTeam) {
      Teams.editTeamOverlay(team);
    };

    const delete_team = function (team: ApiTeam) {
      Teams.deleteTeamOverlay(team);
    };

    const show_members = function (team: ApiTeam) {
      Teams.teamMembersOverlay(team);
    };

    const link = function (name: string, team?: ApiTeam, img_url?: string): HTMLElement {
      const d = div("team-link");
      const img = div("img");
      if (img_url !== undefined) {
        img.style.backgroundImage = "url(" + img_url + ")";
      } else {
        img.innerHTML = name.toUpperCase().substring(0, 1);
      }
      const title = div("team-link-title");
      title.innerHTML = name;

      if (team !== undefined) {
        const menu = Menu.menu();
        d.appendChild(menu.container);

        Menu.add_menu_item(menu, "Members", function () {
          show_members(team);
        });

        const is_admin = Teams.userIsAdmin(App.user, team);
        if (is_admin) {
          const hr = document.createElement("hr");
          menu.options.appendChild(hr);
          Menu.add_menu_item(menu, "Rename", function () {
            rename_team(team);
          });
          Menu.add_menu_item(menu, "Delete", function () {
            delete_team(team);
          });
        }

      }
      d.appendChild(img);
      d.appendChild(title);
      return d;
    };

    let private_img_url: string | undefined = undefined;
    if (App.user && App.user.image_timestamp !== null) {
      // TODO
      //private_img_url = VizApp.user.uploaded_avatar;
    }
    const private_link = link("Private", undefined, private_img_url);
    if (App.user && App.selected_owner_id === App.user.id) {
      private_link.classList.add("selected");
    }
    container.appendChild(private_link);
    private_link.onclick = function () {
      const path = "/";
      history.pushState({}, "", path);
      App.router.match();
    };

    for (const team of App.teams) {
      const l = link(team.name, team);
      if (App.selected_owner_id === team.id) {
        l.classList.add("selected");
      }
      container.appendChild(l);
      l.onclick = function () {
        const path = "/team/" + team.id;
        history.pushState({}, "", path);
        App.router.match();
      };
    }
    const new_link = div("team-link", "new-team-link");
    const new_img = div("img");
    new_img.innerHTML = "+";
    const new_title = div("team-link-title");
    new_title.innerHTML = "Add Team";
    new_link.appendChild(new_img);
    new_link.appendChild(new_title);
    container.appendChild(new_link);
    new_link.onclick = function (e) {
      e.preventDefault();
      if (DropdownState.menu_focused === true) {
        return;
      }
      Teams.newTeamOverlay();
    };
  }

  static section_header(title: string, button_label: string): SectionHeader {
    const header = div("list-header");
    const title_el = span("list-title");
    title_el.innerText = title;
    header.appendChild(title_el);

    const add = div("button");
    add.innerText = button_label;
    header.appendChild(add);

    return {
      button: add,
      container: header,
    }
  }

  static render_main(container: HTMLElement) {
    container.innerHTML = "";
    const d = div("viz-index");

    const data = div("data-list");
    const data_header = FilesPage.section_header("Data", "Add");
    data.appendChild(data_header.container);
    data_header.button.appendChild(SVG.chevron("white"));
    d.appendChild(data);

    const input = Upload.input(App.selected_owner_id);
    data_header.button.appendChild(input);
    const menu = Menu.menu()
    data_header.button.appendChild(menu.container);
    Menu.add_menu_item(menu, "Import CSV", function () {
      input.click();
    })
    Menu.add_menu_item(menu, "Connect to BigQuery", function () {
      Upload.show_key_upload_overlay();
    })
    Menu.add_menu_divider(menu);
    Menu.add_menu_item(menu, "Edit Connections", function () {
      Upload.show_refresh_overlay(App.selected_owner_id);
    })

    const viz_list = div("viz-list");

    const page_header = FilesPage.section_header("Pages", "New");
    viz_list.appendChild(page_header.container);
    const page_list = div("page-list");
    viz_list.appendChild(page_list);

    page_header.button.onclick = function () {
      const req: ApiVizPageCreateRequest = {
        id: uuid(),
        owner_id: App.selected_owner_id,
      }
      Ajax.post("/api/v1/pages", function (data: ApiPage[]) {
        App.build_page_sets(data);
        const path = "/editor/" + req.id;
        history.pushState({}, "", path);
        App.router.match();
      }, req);
    }

    FilesPage.render_data_links(data);
    d.appendChild(viz_list);
    container.appendChild(d);

    let pages: ApiPage[] = [];
    if (App.page_sets[App.selected_owner_id] !== undefined) {
      pages = App.page_sets[App.selected_owner_id];
    }
    FilesPage.render_page_links(pages, page_list, function (page: ApiPage) {
      const path = "/editor/" + page.id;
      history.pushState({}, "", path);
      App.router.match();
    });

  }

  static avatar_url(user: ApiUser): string {
    if (!user.image_timestamp) {
      return "";
    }
    const base = "https://storage.googleapis.com/daytum-thumbnails/";
    const version = new Date(user.image_timestamp).getTime();
    const url = base + user.id + "-120x120.png?" + version;
    return url;
  }

  static render_nav(nav: HTMLElement) {
    nav.innerHTML = "";
    if (!App.user) {
      return;
    }
    nav.appendChild(div("spacer"));
    const avatar = div("user-avatar");
    if (App.user.image_timestamp) {
      const url = FilesPage.avatar_url(App.user);
      avatar.style.backgroundImage = "url(" + url + ")";
    }
    nav.appendChild(avatar);

    const menu = Menu.menu();
    Menu.add_menu_header(menu, App.user.name, App.user.email);
    Menu.add_menu_divider(menu);
    Menu.add_menu_item(menu, "Settings", function () {
      if (!App.user) {
        return;
      }
      const d = div();
      new Overlay(OverlayStyle.Viz, "Settings", [d], "", function () {
        //
      });
      Settings.render_profile_settings(App.user, d);
    });
    Menu.add_menu_divider(menu);
    Menu.add_menu_item(menu, "Sign Out", function () {
      Ajax.get("/api/v1/logout", function () {
        window.location.href = "/";
      })
    });
    menu.options.classList.add("inset");
    avatar.appendChild(menu.container);
  }

}